import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'MyPets' | 'AboutYouForm';

/**
 * Errors related to the About You page
 */
export const Errors = createErrors<Page, Component>('AboutYou')({
    MyPets: {
        // TODO: Add different for ADD and EDIT pet
        SubmitFailed: {
            severity: 'MEDIUM',
            message: 'Failed to add / edit pet',
        },
        RemovePetFailed: {
            severity: 'MEDIUM',
            message: 'Failed to remove pet',
        },
        FetchPetsFailed: {
            severity: 'MEDIUM',
            message: 'Failed to fetch pets',
        },
        UploadPetPhotoFailed: {
            severity: 'MEDIUM',
            message: 'Failed to upload pet photo',
        },
    },
    AboutYouForm: {
        SaveSelectedAddressFailed: {
            severity: 'MEDIUM',
            message: 'Failed to save selected address',
        },
        GetUserDataFailed: {
            severity: 'MEDIUM',
            message: 'Failed to get user data',
        },
    },
});
